import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, X } from 'lucide-react';
import { cn } from '../ui-x';

const InfoCarousel = ({ items = [], autoPlay = true, interval = 4000 }) => {
  const [current, setCurrent] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (items.length > 0) {
      setIsVisible(true);
    }
  }, [items.length]);

  const prev = () =>
    setCurrent((prev) => (prev === 0 ? items.length - 1 : prev - 1));

  const next = () =>
    setCurrent((prev) => (prev === items.length - 1 ? 0 : prev + 1));

  useEffect(() => {
    if (!autoPlay || items.length <= 1) return;
    const timer = setInterval(next, interval);
    return () => clearInterval(timer);
  }, [current, autoPlay, interval, items.length]);

  if (!isVisible || !items.length) return null;

  return (
    <div className='flex h-10 shrink-0 items-center gap-1 border-b bg-brand-orange-100/50 px-2 lg:px-6'>
      <button
        onClick={prev}
        className='shrink-0 rounded-full p-1 text-brand-navy/60 transition-colors hover:bg-card hover:text-brand-navy'
        aria-label='Previous'
      >
        <ChevronLeft className='h-4 w-4' />
      </button>

      <div className='relative flex h-full min-w-0 flex-1 items-center justify-center overflow-hidden'>
        {items.map((item, index) => (
          <p
            key={index}
            className={cn(
              'absolute w-full truncate px-2 text-center text-xs font-medium text-brand-navy transition-all duration-500 sm:text-sm',
              index === current
                ? 'translate-y-0 opacity-100'
                : 'pointer-events-none translate-y-2 opacity-0'
            )}
          >
            {item}
          </p>
        ))}
      </div>

      <button
        onClick={next}
        className='shrink-0 rounded-full p-1 text-brand-navy/60 transition-colors hover:bg-card hover:text-brand-navy'
        aria-label='Next'
      >
        <ChevronRight className='h-4 w-4' />
      </button>

      <div className='ml-1 hidden shrink-0 items-center gap-1 sm:flex'>
        {items.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={cn(
              'h-1.5 w-1.5 rounded-full transition-all duration-300',
              index === current ? 'scale-125 bg-brand-orange' : 'bg-brand-navy/25'
            )}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>

      <button
        onClick={() => setIsVisible(false)}
        className='ml-1 shrink-0 rounded-full p-1 text-brand-navy/60 transition-colors hover:bg-card hover:text-brand-navy'
        aria-label='Dismiss'
      >
        <X className='h-4 w-4' />
      </button>
    </div>
  );
};

export default InfoCarousel;
